import { SynchronizedHistory } from 'mobx-react-router';
import { createContext, useContext } from 'react';

export const HistoryContext = createContext<SynchronizedHistory>(null);

export const useHistory = () => useContext(HistoryContext);
